import { Text } from '@antimatterhq/ui/components/typography';
import { Skeleton } from '@antimatterhq/ui/components/skeleton';
import { DataSourceEventCount } from '@/components/dataSources/dataSourceCardAndTable/dataSourceEventCount/DataSourceEventCount';
import { DataSourceAlertCount } from '@/components/dataSources/dataSourceCardAndTable/dataSourceAlertCount/DataSourceAlertCount';
import { DataSourceSparkline } from '@/components/dataSources/dataSourceCardAndTable/dataSourceSparkline/DataSourceSparkline';
import { DatasourceSummary } from '@/types/api';

interface DataSourceCardMetricsProps {
  summaryWithAlertsAndMetrics: DatasourceSummary;
  isLoadingMetricsAndAlerts: boolean;
}

export const DataSourceCardMetrics = (props: DataSourceCardMetricsProps) => {
  return (
    <>
      <div className="flex w-full flex-col">
        <div className="flex items-baseline gap-1">
          <Text size="sm" semiBold>
            <DataSourceEventCount
              summaryWithAlertsAndMetrics={props.summaryWithAlertsAndMetrics}
              isLoading={props.isLoadingMetricsAndAlerts}
              period="last7days"
            />
          </Text>
          <Text size="sm">events in the last 7 days</Text>
        </div>
        <div className="flex items-baseline gap-1">
          <Text size="sm" semiBold>
            <DataSourceAlertCount
              summaryWithAlertsAndMetrics={props.summaryWithAlertsAndMetrics}
              isLoading={props.isLoadingMetricsAndAlerts}
              period="last7days"
            />
          </Text>
          <Text size="sm">alerts in the last 7 days</Text>
        </div>
      </div>
      <DataSourceSparkline
        summaryWithAlertsAndMetrics={props.summaryWithAlertsAndMetrics}
        isLoading={props.isLoadingMetricsAndAlerts}
        className="ml-auto h-12 w-auto"
      />
    </>
  );
};

export const DataSourceCardMetricsSkeleton = () => {
  return (
    <>
      <div className="flex w-full flex-col space-y-2">
        <Skeleton className="h-4 w-[90%]" />
        <Skeleton className="h-4 w-[90%]" />
      </div>

      <div className="ml-auto flex items-center space-x-3">
        <Skeleton className="mr-3 h-12 w-24" />
      </div>
    </>
  );
};
